module.exports = __webpack_public_path__ + "static/media/scenario2_preview.bff9558e.jpg";